import {useContext} from "react";
import {TodoContext} from "./TodoContextProvider";

export const useTodoContext = () => useContext(TodoContext)
